var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pcHomeTopArr.length>0)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"adBox",style:({backgroundImage: 'url(' + _vm.pcHomeTopArr[0].img + ')'}),on:{"click":function($event){return _vm.swiperClick(_vm.pcHomeTopArr[0])}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }